import { Checkbox } from '@/components/ui/checkbox';
import type { BaseControlProps } from '@/pages/WorkflowsCatalog/components/run/controls/types';
import type { FieldValues } from 'react-hook-form';

const BooleanFormControl = <T extends FieldValues>({ field }: BaseControlProps<T>) => {
  return <Checkbox checked={field.value as boolean} onCheckedChange={field.onChange} />;
};

export default BooleanFormControl;
